import React from 'react'
import PropTypes from 'prop-types'
import Pager from 'components/Pager'
import OrdersTable from './OrdersTable'

export default class OrdersLists extends React.Component {
  static propTypes = {
    orders: PropTypes.array,
    currentPage: PropTypes.number,
    maxPage: PropTypes.number,
    onPageChange: PropTypes.func,
    selectedGroups: PropTypes.object,
    filters: PropTypes.object,
    loading: PropTypes.bool,
    limitedIds: PropTypes.array
  }

  render() {
    const {
      orders,
      loading,
      selectedGroups,
      filters,
      limitedIds
    } = this.props

    return (
      <div className='orders-view_orders'>
        <div className='orders-view_orders-table-wrapper'>
          <OrdersTable
            limitedIds={limitedIds}
            orders={orders}
            loading={loading}
            selectedTouchpoints={selectedGroups}
            filters={filters}
          />
          {this.renderPaging()}
        </div>
      </div>
    )
  }

  renderPaging() {
    const {orders, currentPage, maxPage} = this.props
    if (!orders || !orders.length || !maxPage) return null

    return (
      <div className='orders-view_orders-table-pager'>
        <Pager
          className='container'
          page={currentPage + 1}
          max={maxPage}
          onPageSelect={this.onPageSelect}
        />
      </div>
    )
  }

  onPageSelect = page => {
    this.props.onPageChange(page - 1)
  }
}



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/OrdersList.js